import dayjs, { Dayjs } from 'dayjs';
import { AreaChartDateLabelUnit } from '../../../ui/components/pure/charts/area/area-chart.component';

export enum DateRange {
  Day = 'day',
  Week = 'week',
  Month = 'month',
  HalfYear = 'half year',
  Year = 'year',
  AllTime = 'all time'
}

export function getDateRange(range: DateRange) {
  const to = dayjs();
  let from: Dayjs | null;
  switch (range) {
    case DateRange.Day:
      from = to.startOf('day');
      break;
    case DateRange.Week:
      from = to.subtract(1, 'week').startOf('day');
      break;
    case DateRange.Month:
      from = to.subtract(1, 'month').startOf('day');
      break;
    case DateRange.HalfYear:
      from = to.subtract(6, 'month').startOf('day');
      break;
    case DateRange.Year:
      from = to.subtract(1, 'year').startOf('day');
      break;
    case DateRange.AllTime:
      from = null;
  }
  return { toDate: to.toDate(), fromDate: from?.toDate() };
}

const dateRangeToDateLabelUnitMap: Record<Exclude<DateRange, DateRange.AllTime>, AreaChartDateLabelUnit> = {
  day: AreaChartDateLabelUnit.Hour,
  week: AreaChartDateLabelUnit.Day,
  month: AreaChartDateLabelUnit.Day,
  'half year': AreaChartDateLabelUnit.Month,
  year: AreaChartDateLabelUnit.Month
};

export function getDateLabelUnit(range: DateRange, toDate: Date, fromDate?: Date) {
  if (range !== DateRange.AllTime) {
    return dateRangeToDateLabelUnitMap[range];
  }
  if (!fromDate) {
    return AreaChartDateLabelUnit.Month;
  }
  const duration = dayjs(toDate).diff(fromDate, 'day');
  if (duration <= 1) {
    return AreaChartDateLabelUnit.Hour;
  } else if (duration <= 31) {
    return AreaChartDateLabelUnit.Day;
  } else {
    return AreaChartDateLabelUnit.Month;
  }
}
